import React, { useCallback, useEffect, useRef, useState } from 'react';
import Breadcrumb from './Breadcrumb';
import FooterButton from './FooterButton';
import { getAreaZone, plantDetail, updatePlantAPI } from '../utils/apiServices'
import { useDispatch } from "react-redux";
import { createCoords, zoneDetailsMap } from '../constants/MapContainer';
import { useLocation, useNavigate } from 'react-router-dom';
import { ErrorModal, SuccessModal } from './FormComponents';
import { AUTH_CODE, path_Operation } from '../constants/constVariables';
import BackButton from '../clientComponents/BackButton/BackButton';
import { CustomTab } from '../atomicComponents';
import { useAuthorizationContext } from '../providers/AuthorizationHandler/AuthorizationHandler';
import { postUsageAnalyticsCall, removeDuplicateBasedonKey } from '../constants/Utils';
import { Regex } from '../constants/contants';

const EditPlantMaster = () => {
  const { user, logoutUser } = useAuthorizationContext();
  const location = useLocation();
  const navigate = useNavigate();

  const [isModalOpen, setModalIsOpen] = useState(false);
  const [isErrorModalOpen, setErrorModalIsOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [plant, setPlant] = useState([]);
  const nameRef = useRef("");
  const idRef = useRef("");
  const categoryRef = useRef("");
  const [plantCoordinates, setPlantCoordinates] = useState([]);
  const [pageLeaveTime, setPageLeaveTime] = useState();

  const check = async () => {
    if (location?.state) {
      // console.log("location", location.state.data);
      const response = await plantDetail(location.state.data.plant_id);
      const response2 = await getAreaZone(location.state.data.plant_id);
      // console.log("dataaa = ", response.data.data[0], response2.data.data)
      setPlant(response.data.data[0]);
      createCoords(
        response.data.data[0]?.plant_coordinates[0],
        response.data.data[0]?.zoom,
        response2?.data?.data?.area_data,
        response2?.data?.data?.zone_data,
        (coords) => setSelectedZone(coords),
        true,
        true,
        "Plant",
        false,
        false,
        response?.data?.data[0],
        false,
        plantCoordinates
      )
    }
  }
  const setSelectedZone = async (polygon, coordinates) => {
    const coor = []
    polygon.getPath().getArray().forEach(function (position) {
      coor.push({ lat: position.lat(), lng: position.lng() })
    });
    console.log("polygon = ", polygon, await Object.keys(polygon?.gm_bindings_?.latLngs))
    const closure_key = Object.keys(polygon).find(key => key.match(Regex?.closure_uid));
    console.log("closure_key = ", closure_key);
    if (closure_key) {
      // console.log("closure = ", polygon.closure_uid_461864529);
      console.log("regex match = ", closure_key, polygon[closure_key], plantCoordinates);
      const match = plantCoordinates.some(el => el.closure_uid === polygon[closure_key]);
      // console.log("match = ", match)
      if (match) {
        // console.log("match")
      }
      else {
        // console.log("not match = ", plantCoordinates)
        setPlantCoordinates(prev => [...prev, { closure_uid: polygon[closure_key], coords: coor }])
      }
    }
    // setPlantCoordinates(prev => { if (prev.length > 0) { return [...prev, coor] } else { return [coor] } });
  }
  useEffect(() => {
    check();
    setPageLeaveTime(new Date())
  }, ['']);

  useEffect(() => {
    return () => {
      if (new Date() - pageLeaveTime) {
        const a = path_Operation?.filter((d, i) => {
          return d?.name == location?.pathname
        })
        postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : location?.pathname, pageLeaveTime, a[0]?.operation ? a[0]?.operation : 'view', (new Date() - pageLeaveTime))
      }
    }
  }, [pageLeaveTime])
  useEffect(() => {
    console.log("plantCoordinates updated", plantCoordinates)
    validation();
  }, [plantCoordinates])

  const editArea = async () => {
    const coords = removeDuplicateBasedonKey(plantCoordinates, "closure_uid")
    if (coords && coords.length>0) {
      const payload = {
        plant_id: plant?.plant_id,
        plant_name: plant?.plant_name,
        plant_geofence_coordinates: coords?.map(el=>el?.coords),
        zoom: plant?.zoom,
        updated_by: user?.name,
        updated_by_id: user?.userID,
      }

      console.log("Edit Area Payload = ", payload);
      const response = await updatePlantAPI(payload).then((res) => {
        // console.log(res.data);
        if (res.status === 200) {
          setTitle(res.data.message);
          setModalIsOpen(true);
          // console.log("fdffdfd = ", location?.pathname)
          const a = path_Operation?.filter((d, i) => {
            return d?.name == "edit-plant"
          })
          // console.log("A = ", a[0]?.operation)
          postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : "edit-plant", new Date(), a[0]?.operation ? a[0]?.operation : 'edit', 0)
        }
      }).catch((error) => {
        setTitle(error.response.data.message);
        setErrorModalIsOpen(true);
      });
      // console.log("Response Status", response.status);
    }
    else {
      setTitle("Error getting coordinates. Please try again");
      setErrorModalIsOpen(true);
    }
  }

  const validation = () => {
    // console.log("plantCoordinates inside validation = ", plantCoordinates, plantCoordinates.length);
    if (plantCoordinates.length > 0) {
      buttonToggle("enabled")
    } else {
      buttonToggle("disabled")
    }
  }
  const handleButton = () => {
    if (location?.state?.edit) {
      buttonToggle("disabled")
      editArea();
    }
  }
  const buttonToggle = (value) => {
    if (value === "enabled") {
      const button = document.getElementById("SUBMIT");
      button.disabled = false;
      button.classList.remove("button-disabled");
      button.classList.add("button-enabled");
      button.style.cursor = "pointer";
    }
    else {
      const button = document.getElementById("SUBMIT")
      button.classList.remove("button-enabled");
      button.classList.add("button-disabled")
      button.style.cursor = "unset"
      button.disabled = true;
    }
  };

  return (
    <>
      <div className='breadcrumb'>
        <BackButton basePath={"plant geofence"} action={"edit plant"} handleClick={() => { navigate(-1); }} />
      </div>
      <div className="headerwithcount">
        <div className='countdiv'>
          <CustomTab
            isSelected={false}
            withOutCount
            title={"Edit Plant"}
          />
        </div>
        <div className="blankdiv">
          <span className='vin-search-head-container'>{location?.state?.edit ? null : "Note: Make sure all mandatory fields are filled and the area is plotted."}</span>
        </div>
      </div>
      <div className="vin-details-container">
        <div className="zone-details-main-container">
          <div className="zone-details-header">{location?.state?.edit ? "Edit Area" : "Create Area"}</div>
          <div className="zone-detail-container">
            <div className="zone-detail-inner-container">

              <div className="zone-header-data-container">
                <span className="zone-header area-header">Plant Name</span>
                <div className='errorMessage_container'>
                  <input className='zone-input-fild regularFont' disabled={location?.state?.edit} value={plant.plant_name} type="text" min="0" max="250" onChange={() => validation()} ref={nameRef} />
                  <span id="nameError" className='title'></span>
                </div>
              </div>
              <div className="zone-header-data-container">
                <span className="zone-header area-header">Plant Id</span>
                <div className='errorMessage_container'>
                  <input className='zone-input-fild regularFont' disabled={location?.state?.edit} value={plant.plant_ids} type="text" min="0" max="250" onChange={() => validation()} ref={idRef} />
                  <span id="nameError" className='title'></span>
                </div>
              </div>
              <div className="zone-header-data-container">
                <span className="zone-header area-header">Category</span>
                <div className='errorMessage_container'>
                  <input className='zone-input-fild regularFont' disabled={location?.state?.edit} value={plant.plant_category} type="text" min="0" max="250" onChange={() => validation()} ref={categoryRef} />
                  <span id="nameError" className='title'></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="zone-map-container">
          <div style={{ width: "100%", height: "100%", borderRadius: "12px", boxShadow: "0 3px 6px rgb(0 0 39 / 15%)" }} id="map_container"></div>
          <div id="floating-panel">Delete Polygon</div>
        </div>
      </div>
      <div className="horizontal-line" style={{ marginTop: "1rem" }}></div>
      <div className="vin-details-footer" style={{ flexDirection: "row-reverse" }}>
        <FooterButton shouldEnable={false} value="SUBMIT" backgroundColor="#82C1A7" secondaryColor="#488f71" handle={handleButton} authOperation={AUTH_CODE.CREATE} />
      </div>
      {<SuccessModal open={isModalOpen} handleClose={() => navigate("/plant-master")} title={title} />}
      {<ErrorModal open={isErrorModalOpen} handleClose={() => setErrorModalIsOpen(false)} title={title} />}
      <style jsx>
        {`
                .footer-button {
                    align-items: center;
                    border: none;
                    border-radius: 4px;
                    box-shadow: 0 3px 3px rgb(0 0 67 / 13%);
                    color: #fff;
                    cursor: pointer;
                    display: flex;
                    font-weight: 700;
                    line-height: 19px;
                    padding: 0.5rem 2rem;
                    text-align: center;
                    text-transform: uppercase;
                    white-space: nowrap;
                }
                .vin-search-head-container {
                    text-transform: unset;
                    color: #F17C7C;
                    font-size: var(--smallFontSize);
                    font-weight: 400;
                    padding-left: 10px;
                  }
                  #floating-panel {
                    position: absolute;
                    top: 10px;
                    left: 100px;
                    display: none;
                    background: rgb(241, 124, 124);
                    padding-box rgb(255, 255, 255);
                    border: 0;
                    cursor: pointer;
                    margin: 0;
                    display: none;
                    outline: 0;
                    align-items: center;
                    user-select: none;
                    border-radius: 0;
                    vertical-align: middle;
                    -moz-appearance: none;
                    justify-content: center;
                    text-decoration: none;
                    -webkit-appearance: none;
                    -webkit-tap-highlight-color: rgb(241, 124, 124);;
                    color: #fff;
                    padding: 11px 23px;
                    font-size: 0.875rem;
                    min-width: 64px;
                    box-sizing: border-box;
                    transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
                    font-weight: 600;
                    line-height: 1.75;
                    border-radius: 4px;
                    letter-spacing: 0.02857em;
                    text-transform: uppercase;
                    font-size: var(--smallFontSize);
                }
                #floating-panel:hover {
                    background: #ea3a3a;
                    color: #fff;
                }
                .gmnoprint[role=menubar]{
                    display: flex;
                    right: 55px !important;
                    top: 10px !important;
                    border-radius: 6px;
                    display: flex;
                    margin: 0 !important;
                }
                .gmnoprint[role=menubar] > div > button {
                    background: #FFFFFF !important;
                    box-shadow: 0px 3px 6px rgba(0, 0, 41, 0.1) !important;
                    border-radius: 6px !important;
                    margin: 0 5px !important;
                    display: flex !important;
                    align-items: center;
                    justify-content: center;
                    width: 40px;
                    height: 40px;                    
                }
                    `}
      </style>
    </>
  )
}

export default EditPlantMaster